import React from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import {withFormik} from 'formik';
import {object, string} from 'yup';
import Button from "@material-ui/core/Button";

import i18n from '../../i18n';
import {mergeWithDefault} from "../Form/utils";
import FormField from '../Form/FormField';
import FormSelect from "../Form/FormSelect";

const InnerForm = ({
   values,
   errors,
   attributeGroups,
   touched,
   setFieldValue,
   handleChange,
   handleBlur,
   handleSubmit,
   isSubmitting,
   cancelUrl
}) => (
    <form onSubmit={handleSubmit}>
        <FormSelect
            name="attribute_group"
            label={i18n.get('attribute.group.form.group')}
            error={errors.parent_id}
            touched={touched.parent_id}
            onChange={selectedOption =>
                setFieldValue(
                    "parent_id",
                    selectedOption.value
                )
            }
            onBlur={handleBlur}
            options={
                [{_id: '', id: '', name_chain: 'root ▶ '}]
                    .concat(attributeGroups)
                    .map(group => ({value: group.id, label: group.name_chain}))
            }
            value={values.parent_id}
        />

        <FormField
            label={i18n.get('attribute.group.form.name')}
            type="text"
            name="name"
            error={errors.name}
            touched={touched.name}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.name}
        />

        <Button
            disabled={isSubmitting}
            variant="contained"
            color="primary"
            type="submit"
        >
            {i18n.get('attribute.submit')}
        </Button>
    </form>
);

const AttributeGroupForm = withFormik({
    mapPropsToValues: props => {
        return mergeWithDefault(props.values, {
            name: '',
            parent_id: '',
        });
    },
    validationSchema: object().shape({
        name: string()
            .required(i18n.get('validation.required', {attribute: i18n.get('attribute.group.form.name')})),
    }),
    handleSubmit: (values,
                   {
                       props,
                       setSubmitting,
                       setErrors,
                   }) => {
        setSubmitting(true);

        axios({
            method: props.method,
            url: props.url,
            data: values,
        })
            .then(response => {
                setSubmitting(false);
                let data = response.data;


                // Show success message.
                return swal({
                    text: i18n.get('attribute.group.saved.success'),
                    icon: "success",
                }).then(() => {
                    if (data.forward) {
                        window.location.href = data.forward;
                    }
                });
            })
            .catch(error => {
                setSubmitting(false);

                if (error.response && error.response.data && error.response.data.errors) {
                    setErrors(error.response.data.errors);
                }

                // Show error message.
                return swal({
                    text: i18n.get('attribute.group.saved.error'),
                    icon: "error",
                });
            });
    },
})(InnerForm);

export default AttributeGroupForm;
